"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProApiObfuscationResult = void 0;
class ProApiObfuscationResult {
    constructor(code, sourceMap = '') {
        this.obfuscatedCode = code;
        this.sourceMapValue = sourceMap;
    }
    getObfuscatedCode() {
        return this.obfuscatedCode;
    }
    getSourceMap() {
        return this.sourceMapValue;
    }
    getIdentifierNamesCache() {
        return null;
    }
    toString() {
        return this.obfuscatedCode;
    }
}
exports.ProApiObfuscationResult = ProApiObfuscationResult;
